/* GreenBridge Premium — theme.js v2.0 */

// Delivery Configuration
const SAME_DAY_PINCODES = ["560046","560003","560006","560052","560080","560002","560045","560020","560024","560092","560064","560032","560043","560063","560090","560049","560007","560030"];
const CUTOFF_HOUR = 18;
const CUTOFF_MINUTE = 30;

function getPincodeDeliveryInfo(pincode) {
  const isInRange = SAME_DAY_PINCODES.includes(pincode.trim());
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const isPastCutoff = currentHour > CUTOFF_HOUR || (currentHour === CUTOFF_HOUR && currentMinute >= CUTOFF_MINUTE);

  if (isInRange && !isPastCutoff) {
    return { isSameDay: true, message: "🚚 Order before 6:30 PM for same-day delivery!", badge: "SAME-DAY" };
  } else {
    return { isSameDay: false, message: "📅 Your order will be delivered by tomorrow", badge: "NEXT-DAY" };
  }
}

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Sticky header shadow ---- */
  const header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ---- Mobile Menu ---- */
  const mobileBtn = document.getElementById('mobileMenuBtn');
  const mobileNav = document.getElementById('mobileNav');
  if (mobileBtn && mobileNav) {
    mobileBtn.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      mobileBtn.classList.toggle('open', open);
      mobileBtn.setAttribute('aria-expanded', open);
    });
  }

  /* ---- Hero Slideshow ---- */
  const slides = document.querySelectorAll('.slide');
  const dots = document.querySelectorAll('.dot');
  if (slides.length > 1) {
    let current = 0;
    let timer;
    function goTo(n) {
      slides[current].classList.remove('active');
      dots[current] && dots[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current] && dots[current].classList.add('active');
    }
    function next() { goTo(current + 1); }
    function startAuto() { timer = setInterval(next, 5500); }
    function stopAuto() { clearInterval(timer); }
    startAuto();
    document.querySelector('.slide-arrow.next') && document.querySelector('.slide-arrow.next').addEventListener('click', function () { stopAuto(); next(); startAuto(); });
    document.querySelector('.slide-arrow.prev') && document.querySelector('.slide-arrow.prev').addEventListener('click', function () { stopAuto(); goTo(current - 1); startAuto(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stopAuto(); goTo(i); startAuto(); });
    });
    // Pause on hover
    const hero = document.querySelector('.hero-slideshow');
    if (hero) {
      hero.addEventListener('mouseenter', stopAuto);
      hero.addEventListener('mouseleave', startAuto);
    }
  }

  /* ---- Product Page: Image Thumbnails ---- */
  const thumbs = document.querySelectorAll('.thumb');
  const mainImg = document.getElementById('mainImg');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const img = thumb.querySelector('img');
        if (img) {
          mainImg.src = img.src.replace('200x200', '800x800');
          mainImg.style.opacity = '0';
          setTimeout(function () { mainImg.style.opacity = '1'; }, 80);
        }
      });
    });
  }

  /* ---- Product Page: Variant Selection ---- */
  const variantBtns = document.querySelectorAll('.variant-btn');
  const priceDisplay = document.getElementById('currentPrice');
  if (variantBtns.length) {
    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        variantBtns.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        if (priceDisplay && btn.dataset.price) {
          priceDisplay.textContent = '₹' + btn.dataset.price;
        }
        // Update WhatsApp button text
        const waBtn = document.getElementById('waOrderBtn');
        if (waBtn && btn.dataset.weight) {
          const title = document.querySelector('.product-detail h1');
          const productName = title ? title.textContent.trim() : 'mangoes';
          waBtn.href = 'https://wa.me/' + (window.__WA_NUMBER || '918050087595') + '?text=Hi%20GreenBridge!%20I%20want%20to%20order%20' + encodeURIComponent(productName) + '%20-%20' + encodeURIComponent(btn.dataset.weight) + '.%20Please%20confirm.';
        }
      });
    });
  }

  /* ---- Collection Page: Card Variant Selector ---- */
  const cardVariantBtns = document.querySelectorAll('.card-variant-btn');
  cardVariantBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.product-card');
      if (!card) return;
      card.querySelectorAll('.card-variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const price = btn.dataset.price;
      const priceEl = card.querySelector('.price-main');
      if (priceEl && price) priceEl.textContent = '₹' + price;
    });
  });

  /* ---- Cart: Quantity Controls ---- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const item = btn.closest('.cart-item');
    if (!item) return;
    const valEl = item.querySelector('.qty-val');
    const input = item.querySelector('input[name="updates[]"]');
    let val = parseInt(valEl ? valEl.textContent : 1) || 1;
    if (btn.classList.contains('qty-plus')) val = Math.min(val + 1, 99);
    if (btn.classList.contains('qty-minus')) val = Math.max(val - 1, 1);
    if (valEl) valEl.textContent = val;
    if (input) input.value = val;
  });

  /* ---- Smooth fade for main img ---- */
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.25s ease';
  }

  /* ---- Intersection observer for card animations ---- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.product-card, .review-card, .value-card, .contact-info-card').forEach(function (el) {
      el.style.animationPlayState = 'paused';
      observer.observe(el);
    });
  }

  /* ---- Pincode Checker ---- */
  const pincodeInput = document.getElementById('pincodeChecker');
  const deliveryMessage = document.getElementById('deliveryMessage');
  if (pincodeInput && deliveryMessage) {
    pincodeInput.addEventListener('input', function() {
      const pincode = this.value.trim();
      if (pincode.length === 6 && /^\d+$/.test(pincode)) {
        const info = getPincodeDeliveryInfo(pincode);
        deliveryMessage.className = info.isSameDay ? 'delivery-msg same-day' : 'delivery-msg next-day';
        deliveryMessage.innerHTML = `<span class="delivery-badge">${info.badge}</span> ${info.message}`;
        deliveryMessage.style.display = 'block';
      } else if (pincode.length > 0) {
        deliveryMessage.innerHTML = '⏳ Checking...';
        deliveryMessage.style.display = 'block';
      } else {
        deliveryMessage.style.display = 'none';
      }
    });
  }

});

/* ---- PINCODE POPUP MODAL (Mandatory) ---- */
function initPincodeModal() {
  const modalShown = localStorage.getItem('pincodeModalShown');
  if (modalShown) return; // Don't show again in this session

  setTimeout(function() {
    const modal = document.getElementById('pincodeModal');
    if (!modal) return;
    modal.classList.add('visible');
    localStorage.setItem('pincodeModalShown', '1');
  }, 5000); // Show after 5 seconds
}

function closePincodeModal(bypass) {
  const modal = document.getElementById('pincodeModal');
  if (!modal) return;

  if (!bypass) {
    const pincode = document.getElementById('modalPincodeInput');
    if (pincode && pincode.value.trim().length !== 6) {
      pincode.classList.add('shake');
      setTimeout(() => pincode.classList.remove('shake'), 500);
      return; // Don't close if empty
    }
  }

  modal.classList.remove('visible');
}

// Scroll animations
function initScrollAnimations() {
  if ('IntersectionObserver' in window) {
    const observerOptions = { threshold: 0.15, rootMargin: '0px 0px -50px 0px' };
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
  }
}

// Mango scroll animations
function initScrollMangoAnimations() {
  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    // Activate mangoes at different scroll points
    const mango1 = document.querySelector('.mango-scroll-1');
    const mango2 = document.querySelector('.mango-scroll-2');
    const mango3 = document.querySelector('.mango-scroll-3');
    const mango4 = document.querySelector('.mango-scroll-4');

    if (scrollY > windowHeight * 0.5) {
      mango1?.classList.add('active');
      mango3?.classList.add('active');
    }

    if (scrollY > windowHeight * 1) {
      mango2?.classList.add('active');
      mango4?.classList.add('active');
    }

    if (scrollY < windowHeight * 0.4) {
      mango1?.classList.remove('active');
      mango3?.classList.remove('active');
    }

    if (scrollY < windowHeight * 0.8) {
      mango2?.classList.remove('active');
      mango4?.classList.remove('active');
    }
  }, { passive: true });
}

// Update all contact numbers
function updateContactNumbers() {
  const phone = '918296237595';
  const url = 'https://wa.me/' + phone;

  document.querySelectorAll('[data-wa-link]').forEach(el => {
    el.href = url;
  });

  document.querySelectorAll('[data-phone]').forEach(el => {
    el.textContent = '+91 82962 37595';
  });

  window.__WA_NUMBER = phone;
}

document.addEventListener('DOMContentLoaded', function() {
  updateContactNumbers();
  initPincodeModal();
  initScrollAnimations();
  initScrollMangoAnimations();

  /* Modal Pincode Input Listener */
  const modalPincodeInput = document.getElementById('modalPincodeInput');
  const modalDeliveryMessage = document.getElementById('modalDeliveryMessage');
  if (modalPincodeInput) {
    modalPincodeInput.addEventListener('input', function() {
      const pincode = this.value.trim();
      if (pincode.length === 6 && /^\d+$/.test(pincode)) {
        const info = getPincodeDeliveryInfo(pincode);
        modalDeliveryMessage.className = 'modal-delivery-message ' + (info.isSameDay ? 'same-day' : 'next-day');
        modalDeliveryMessage.innerHTML = `<span class="delivery-badge">${info.badge}</span> ${info.message}`;
        modalDeliveryMessage.style.display = 'block';
      } else {
        modalDeliveryMessage.style.display = 'none';
      }
    });
  }
});

/* ---- Add to Cart ---- */
function addToCart(event, variantId) {
  event.preventDefault();
  var id = variantId;
  if (!id) {
    var selected = document.querySelector('.variant-btn.selected');
    id = selected ? selected.dataset.variantId : null;
  }
  if (!id || id === 'undefined') {
    window.location.href = '/cart';
    return;
  }
  var btn = event.currentTarget;
  var orig = btn ? btn.innerHTML : '';
  if (btn) { btn.innerHTML = '⏳ Adding...'; btn.style.pointerEvents = 'none'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: 1 })
  }).then(function (res) { return res.json(); }).then(function () {
    if (btn) { btn.innerHTML = '✅ Added to Cart!'; }
    // Update cart count
    fetch('/cart.js').then(r => r.json()).then(function (cart) {
      var countEl = document.querySelector('.cart-count');
      if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
    });
    setTimeout(function () {
      if (btn) { btn.innerHTML = orig; btn.style.pointerEvents = ''; }
    }, 2000);
  }).catch(function () {
    window.location.href = '/cart';
  });
}

/* ---- Collection Quick Add ---- */
function quickAdd(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  if (!variantId || variantId === '0' || variantId === 'undefined') {
    // Navigate to product for variant selection
    var card = event.currentTarget.closest('.product-card');
    var link = card ? card.querySelector('a[href]') : null;
    if (link) window.location.href = link.href;
    return;
  }
  var btn = event.currentTarget;
  var orig = btn.innerHTML;
  btn.innerHTML = '⏳';
  btn.style.pointerEvents = 'none';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(r => r.json()).then(function () {
    btn.innerHTML = '✅';
    fetch('/cart.js').then(r => r.json()).then(function (cart) {
      var countEl = document.querySelector('.cart-count');
      if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = 'flex'; }
    });
    setTimeout(function () { btn.innerHTML = orig; btn.style.pointerEvents = ''; }, 2000);
  }).catch(function () {
    btn.innerHTML = orig;
    btn.style.pointerEvents = '';
  });
}

/* ---- Product Page: Quantity-aware Add to Cart ---- */
function addToCart(event) {
  event.preventDefault();
  var selected = document.querySelector('.variant-btn.selected');
  var variantId = selected ? selected.dataset.variantId : null;
  var qty = parseInt(document.getElementById('qtyVal') ? document.getElementById('qtyVal').textContent : 1) || 1;

  if (!variantId || variantId === 'undefined') {
    window.location.href = '/cart';
    return;
  }
  var btn = event.currentTarget;
  var orig = btn ? btn.innerHTML : '';
  if (btn) { btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg> Adding...'; btn.style.pointerEvents = 'none'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  }).then(function(r) { return r.json(); }).then(function() {
    if (btn) btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20,6 9,17 4,12"/></svg> ADDED TO CART!';
    fetch('/cart.js').then(r => r.json()).then(function(cart) {
      var c = document.querySelector('.cart-count');
      if (c) { c.textContent = cart.item_count; c.style.display = 'flex'; }
    });
    setTimeout(function() {
      if (btn) { btn.innerHTML = orig; btn.style.pointerEvents = ''; }
    }, 2500);
  }).catch(function() {
    window.location.href = '/cart';
  });
}
